var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadsetMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_232_981",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.765564,
    width: 32.4025,
    height: 32.4025,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_232_981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2017 31.8179V29.1176H25.6524V27.7675H20.252V16.9667H25.6524V15.6166C25.6524 13.0064 24.7299 10.7788 22.8847 8.93361C21.0396 7.08847 18.8119 6.1659 16.2017 6.1659C13.5915 6.1659 11.3638 7.08847 9.5187 8.93361C7.67356 10.7788 6.75099 13.0064 6.75099 15.6166V16.9667H12.1514V27.7675H6.75099C6.00843 27.7675 5.37276 27.5032 4.84397 26.9744C4.31518 26.4456 4.05078 25.8099 4.05078 25.0673V15.6166C4.05078 13.9515 4.37143 12.382 5.01273 10.9081C5.65403 9.43428 6.52597 8.14605 7.62855 7.04347C8.73114 5.94089 10.0194 5.06895 11.4932 4.42765C12.9671 3.78635 14.5366 3.4657 16.2017 3.4657C17.8668 3.4657 19.4363 3.78635 20.9102 4.42765C22.3841 5.06895 23.6723 5.94089 24.7749 7.04347C25.8774 8.14605 26.7494 9.43428 27.3907 10.9081C28.032 12.382 28.3526 13.9515 28.3526 15.6166V29.1176C28.3526 29.8602 28.0882 30.4959 27.5594 31.0247C27.0307 31.5535 26.395 31.8179 25.6524 31.8179H16.2017ZM6.75099 25.0673H9.45119V19.6669H6.75099V25.0673ZM22.9522 25.0673H25.6524V19.6669H22.9522V25.0673Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetMic);
export default __webpack_public_path__ + "static/media/headset_mic.7d3ded306a186796ed8109b0db9c1f7d.svg";
export { ForwardRef as ReactComponent };